import React from 'react';
import {
    FaCheck,
    FaLaptopCode,
    FaCubes,
    FaMobileAlt,
    FaCloudUploadAlt,
    FaServer,
    FaCrown,
} from 'react-icons/fa';
import classes from './Pricing.module.scss';

const pricingPlans = [
    {
        icon: <FaLaptopCode />,
        service: 'Website Development',
        price: '₹999',
        featured: false,
        features: [
            'Responsive multi-page design',
            'SEO-optimized structure',
            'Contact forms & lead capture',
            'Performance optimization',
            'Cross-browser compatibility',
        ],
    },
    {
        icon: <FaCubes />,
        service: 'Web Applications',
        price: '₹999',
        featured: false,
        features: [
            'Custom dashboard & admin panel',
            'User authentication system',
            'Database integration',
            'REST API development',
            'Real-time data handling',
        ],
    },
    {
        icon: <FaMobileAlt />,
        service: 'Mobile Applications',
        price: '₹4,999',
        featured: true,
        label: 'Most Popular',
        features: [
            'Cross-platform (iOS & Android)',
            'Push notifications setup',
            'Offline-first architecture',
            'App Store submission',
            'In-app payment integration',
            'Analytics & crash reporting',
        ],
    },
    {
        icon: <FaCloudUploadAlt />,
        service: 'Cloud Services',
        price: '₹1,999',
        featured: false,
        features: [
            'Cloud architecture design',
            'CI/CD pipeline setup',
            'Auto-scaling configuration',
            'Security & monitoring',
            'Cost optimization audit',
        ],
    },
    {
        icon: <FaServer />,
        service: 'Backend & API',
        price: '₹2,999',
        featured: false,
        features: [
            'RESTful / GraphQL APIs',
            'Microservice architecture',
            'Database design & tuning',
            'Third-party integrations',
            'Load testing & optimization',
        ],
    },
];

const Pricing = () => {
    return (
        <section id="pricing" className={classes.pricing}>
            <div className={classes.container}>
                {/* Header */}
                <div className={classes.header}>
                    <span className={classes.badge}>Pricing</span>
                    <h2 className={classes.title}>
                        Transparent <span className={classes.gradient}>Pricing</span>
                    </h2>
                    <p className={classes.subtitle}>
                        Every project is unique, but here are our minimum starting prices
                        to help you plan your investment.
                    </p>
                </div>

                {/* Pricing Columns */}
                <div className={classes.columns}>
                    {pricingPlans.map((plan, index) => (
                        <div
                            key={index}
                            className={`${classes.column} ${plan.featured ? classes.featured : ''}`}
                        >
                            {plan.featured && (
                                <div className={classes.popularTag}>
                                    <FaCrown className={classes.crownIcon} />
                                    {plan.label}
                                </div>
                            )}

                            {/* Icon */}
                            <div className={classes.iconCircle}>
                                {plan.icon}
                            </div>

                            {/* Service name */}
                            <h3 className={classes.serviceName}>{plan.service}</h3>

                            {/* Price */}
                            <div className={classes.priceBlock}>
                                <span className={classes.startingFrom}>starting from</span>
                                <span className={classes.price}>{plan.price}</span>
                            </div>

                            {/* Divider */}
                            <div className={classes.divider} />

                            {/* Features */}
                            <ul className={classes.featureList}>
                                {plan.features.map((feature, fIdx) => (
                                    <li key={fIdx} className={classes.featureItem}>
                                        <FaCheck className={classes.checkIcon} />
                                        <span>{feature}</span>
                                    </li>
                                ))}
                            </ul>

                            {/* Card CTA */}
                            <a
                                href="#contact"
                                className={`${classes.cardBtn} ${plan.featured ? classes.cardBtnFeatured : ''}`}
                            >
                                Get Quote
                            </a>
                        </div>
                    ))}
                </div>

                {/* Bottom note */}
                <p className={classes.bottomNote}>
                    Final pricing depends on features, integrations, and project scale.
                    <a href="#contact" className={classes.talkLink}> Let's talk →</a>
                </p>
            </div>
        </section>
    );
};

export default Pricing;
